import { useState } from "react";
import { API } from "aws-amplify";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FormWrapper = styled.form`
  max-width: 500px;
  margin: 40px auto;
  padding: 30px;
  background: #f9f9f9;
  border-radius: 0px;
  box-shadow: 0 6px 15px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 600px) {
    padding: 20px;
    margin: 20px;
  }
`;

const Input = styled.input`
  padding: 12px 15px;
  border-radius: 0px;
  border: 1px solid #ccc;
  font-size: 16px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #690A62;
    box-shadow: 0 0 5px rgba(105, 10, 98, 0.3);
  }
`;

const TextArea = styled.textarea`
  padding: 12px 15px;
  border-radius: 0px;
  border: 1px solid #ccc;
  font-size: 16px;
  width: 100%;
  min-height: 120px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #690A62;
    box-shadow: 0 0 5px rgba(105, 10, 98, 0.3);
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;

  input {
    margin-right: 10px;
  }
`;

const Button = styled.button`
  padding: 12px 20px;
  font-size: 18px;
  font-weight: bold;
  background-color: #690A62;
  color: white;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #a1ac9e;
    color: #000;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const StatusMessage = styled.p`
  color: ${({ success }) => (success ? "green" : "red")};
  font-weight: bold;
`;

export const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    consent: false,
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const sendEmail = async () => {
    const apiName = "Atenida2";
    const path = "/contact";
    const myInit = { body: form };

    try {
      const resp = await API.post(apiName, path, myInit);

      if (resp.ResponseMetadata?.HTTPStatusCode === 200) {
        setStatus("success");
        setForm({ name: "", email: "", phone: "", message: "", consent: false });
      } else {
        setStatus("error");
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message || !form.consent) {
      alert("Wypełnij wszystkie wymagane pola i zaakceptuj RODO");
      return;
    }
    sendEmail();
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <Input type="text" name="name" placeholder="Imię *" value={form.name} onChange={handleChange} required />
      <Input type="email" name="email" placeholder="Email *" value={form.email} onChange={handleChange} required />
      <Input type="tel" name="phone" placeholder="Telefon" value={form.phone} onChange={handleChange} />
      <TextArea name="message" placeholder="Treść wiadomości *" value={form.message} onChange={handleChange} required />
      <Label>
        <input type="checkbox" name="consent" checked={form.consent} onChange={handleChange} required />
        Wyrażam zgodę na kontakt ( <Link to="/privacy" className="privacy-link">
    RODO
  </Link>) 
      </Label>
      <Button type="submit">Wyślij</Button>
      {status === "success" && <StatusMessage success>Wiadomość wysłana!</StatusMessage>}
      {status === "error" && <StatusMessage>Wystąpił błąd, spróbuj ponownie.</StatusMessage>}
    </FormWrapper>
  );
};

export default ContactForm;